import * as types from './actionTypes';

export const setIframeIntegrationRequest = (iframeIntegrationRequest) => ({
  type: types.SET_IFRAME_INTEGRATION_REQUEST,
  payload: {iframeIntegrationRequest}
})

export const setIframeIntegrationResponse = (iframeIntegrationResponse) => ({
  type: types.SET_IFRAME_INTEGRATION_RESPONSE,
  payload: {iframeIntegrationResponse}
})
